import React from 'react'
import Common from '../Common';

const About = () => {

  return (
   <Common 
   name='Welcome To About Page'
   img = 'https://i.pinimg.com/originals/3e/55/2f/3e552ff46b95bd34259c0025279873fc.gif'
   visit='/Contact'
   ragistration = './Ragistration'
   btName = 'Contact Me'
   btName1='Ragistration'
   />
  )
}

export default About;